import { type PartnerId, PARTNER_NATIONAL_ID } from '../types/PartnerId'

export const isAvailablePartner = (
  partnerId: PartnerId = PARTNER_NATIONAL_ID,
  partners?: Array<PartnerId>,
): boolean => {
  if (!partners?.length) {
    return true
  }

  return partners.includes(partnerId)
}
